import { render, staticRenderFns } from "./RentalContainer.vue?vue&type=template&id=2005c020"
import script from "./RentalContainer.vue?vue&type=script&lang=js"
export * from "./RentalContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports